/*
 * Public API Surface of plugin-statistics
 */

export * from './lib/statistics.module';
export * from './lib/services/day-statistic.service';
export * from './lib/models/day-stats';
export * from './lib/models/life-section-stats';
